import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import MarketingLayout from './marketing/MarketingLayout';
import { HomePage, AgentsPage, ProblemPage, ResultsPage } from './marketing/pages';
import Register from './pages/Register';
import CampaignWizard from './pages/CampaignWizard';
import Selection from './pages/Selection';
import Schedule from './pages/Schedule';
import Tracker from './pages/Tracker';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Demo from './pages/Demo';
import './App.css';

function App() {
  const Auth = ({ children }) => localStorage.getItem('user_email') ? <Layout>{children}</Layout> : <Navigate to="/login" />;
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MarketingLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/agents" element={<AgentsPage />} />
          <Route path="/problem" element={<ProblemPage />} />
          <Route path="/results" element={<ResultsPage />} />
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/wizard" element={<Auth><CampaignWizard /></Auth>} />
        <Route path="/selection" element={<Auth><Selection /></Auth>} />
        <Route path="/schedule" element={<Auth><Schedule /></Auth>} />
        <Route path="/tracker" element={<Auth><Tracker /></Auth>} />
        <Route path="/dashboard" element={<Auth><Dashboard /></Auth>} />
        <Route path="/profile" element={<Auth><Profile /></Auth>} />
        <Route path="*" element={<Navigate to="/" />} />
        {/* <Route path="*" element={<Navigate to="/login" />} /> */}
      </Routes>
    </BrowserRouter>
  );
}
export default App;